export default [{
  path: "/evaluation",
  name: "evaluation",
  meta: {
    title: "测评系统",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/evaluation/home/index.vue")
}, {
  path: "/evaluation/choose",
  name: "evaluationChoose",
  meta: {
    title: "测评介绍",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/evaluation/choose/index.vue")
}, {
  path: "/evaluation/detail",
  name: "evaluationDetail",
  meta: {
    title: "测评详情",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/evaluation/detail/index.vue")
}, {
  path: "/evaluation/result",
  name: "evaluationResult",
  meta: {
    title: "测评结果",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/evaluation/result/index.vue")
}, {
  path: "/evaluation/my",
  name: "evaluationMy",
  meta: {
    title: "我的测评",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/evaluation/my/index.vue")
}]